"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStatesCSS = void 0;

var styled_components_1 = require("styled-components");

var theme_1 = require("../theme");

exports.InputStatesCSS = (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  if (props.disabled) {
    return (0, styled_components_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background: ", ";\n      "])), theme_1.theme.colors.white[700]);
  }
}, function (props) {
  if (props.isValid === false) {
    return (0, styled_components_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        box-shadow: inset 0 -1px 1px ", ";\n        color: ", ";\n      "])), theme_1.theme.colors.red[500], theme_1.theme.colors.red[500]);
  }
});